<template>
    <div>
        <slglrs-base-header-sec :title="headerParams.title" :slug="headerParams.slug"></slglrs-base-header-sec>

        <!--        <h1>Stranica nije uradjena preba je preraditi!!!!</h1>-->
        <div class="container-fluid base-container">
            <div class="base-box p-normal">

                <iframe :style="iframeStyle" @load="load" ref="ifr" id="ifr" class="static-iframe" width="100%"
                    :src="baseApiUrl + 'prins/static/page/' + paramsCode + '/' + paramsPage" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import SlglrsBaseHeaderSec from '@/base_pages/slglrs/SlglrsBaseHeaderSec.vue';


export default {
    name: "SlglrsStaticPage",
    data() {
        return {
            iframeStyle: {
                height: '600px',
            },
            loaded: false,
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },

        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        SlglrsBaseHeaderSec,
    },
    methods: {
        load: function () {
            this.loaded = true;
        }
    },
    watch: {
        $route() {
            if (this.$route.query.page === 'contact' || this.$route.query.page === 'impresum') {
                this.iframeStyle.height = '440px';
            } else {
                this.iframeStyle.height = '600px';
            }
        }
    },
    mounted() {
        if (this.$route.query.page === 'contact' || this.$route.query.page === 'impresum') {
            this.iframeStyle.height = '440px';
        } else {
            this.iframeStyle.height = '600px';
        }

        // if(this.paramsPage === 'impresum'){
        //     this.height = '400px'
        // }
    },
    computed: {
        paramsGroup() {
            return this.$route.query.group;
        },
        paramsCode() {
            return this.$route.query.code;
        },
        paramsPage() {
            return this.$route.query.page;
        },
        headerParams() {


            let code;
            let title;
            console.log(this.$route.query.code);
            switch (this.$route.query.code) {
                case 'NP':
                    title = 'Службени гласник рс';
                    code = 'NP';
                    break;
                case 'MUTG':
                    title = 'Службени гласник рс међународни уговори';
                    code = 'MUTG';
                    break;
                case 'PG2010':
                    title = 'Службени гласник рс просветни гласник';
                    code = 'PG2010';
                    break;
                default:
                // code block
            }
            return { title: title, slug: code }
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_slglrs';
    }
}
</script>

<style scoped></style>
